/* GERADO por backend/testes/licenca-das-leituras.test.ts — nao edite a mao.
   A licenca que cada rota de LEITURA exige no servidor (config.exige). Para
   regerar: ATUALIZAR_LICENCAS=1 npx vitest run backend/testes/licenca-das-leituras.test.ts */

export const LICENCAS_DAS_LEITURAS: Readonly<Record<string, string>> = {
  '/cadastros/administracao/resumo': 'governanca.ler',
  '/cadastros/alcadas': 'governanca.ler',
  '/cadastros/centros-de-custo': 'cadastro.ler',
  '/cadastros/clientes': 'cadastro.ler',
  '/cadastros/contratos': 'cadastro.ler',
  '/cadastros/convites/entrega': 'governanca.ler',
  '/cadastros/filiais': 'cadastro.ler',
  '/cadastros/fornecedores': 'cadastro.ler',
  '/cadastros/obras': 'cadastro.ler',
  '/cadastros/papeis': 'governanca.ler',
  '/cadastros/papeis/:id/permissoes': 'governanca.ler',
  '/cadastros/permissoes': 'governanca.ler',
  '/cadastros/trilha': 'auditoria.ler',
  '/cadastros/usuarios': 'governanca.ler',
  '/cadastros/usuarios/:id/sessoes': 'governanca.ler',
  '/catalogo/configuracoes': 'catalogo.ler',
  '/catalogo/fabricantes': 'catalogo.ler',
  '/catalogo/modelos': 'catalogo.ler',
  '/combustivel/abastecimentos': 'combustivel.ler',
  '/combustivel/ajustes': 'combustivel.ler',
  '/combustivel/cadastros': 'combustivel.ler',
  '/combustivel/cadastros/postos': 'combustivel.ler',
  '/combustivel/cadastros/produtos': 'combustivel.ler',
  '/combustivel/cadastros/tanques': 'combustivel.ler',
  '/combustivel/cobrancas': 'combustivel.ler',
  '/combustivel/folhas': 'combustivel.ler',
  '/combustivel/folhas/:id': 'combustivel.ler',
  '/combustivel/folhas/leituras/:id/arquivo': 'combustivel.ler',
  '/combustivel/lubrificantes': 'combustivel.ler',
  '/combustivel/ordens': 'combustivel.ler',
  '/combustivel/pacote-do-campo': 'combustivel.ler',
  '/combustivel/pacote-do-campo/avisos': 'combustivel.ler',
  '/combustivel/postos': 'combustivel.ler',
  '/combustivel/tanques': 'combustivel.ler',
  '/combustivel/tanques/:id/movimentos': 'combustivel.ler',
  '/combustivel/transferencias': 'combustivel.ler',
  '/compras/necessidade': 'compras.ler',
  '/compras/pedidos': 'compras.ler',
  '/compras/pedidos/:id': 'compras.ler',
  '/compras/requisicoes': 'compras.ler',
  '/custos/configuracao': 'custo.ler',
  '/custos/depreciacao': 'custo.ler',
  '/custos/equipamentos': 'custo.ler',
  '/custos/indireto': 'custo.ler',
  '/custos/valor-hora': 'custo.ler',
  '/equipamentos': 'equipamento.ler',
  '/equipamentos/:id': 'equipamento.ler',
  '/equipamentos/:id/alocacoes': 'alocacao.ler',
  '/equipamentos/:id/documentos': 'documento_tecnico.ler',
  '/equipamentos/:id/documentos/busca': 'documento_tecnico.ler',
  '/equipamentos/:id/foto': 'equipamento.ler',
  '/equipamentos/:id/perguntas': 'ia.perguntar',
  '/equipamentos/:id/prontuario': 'prontuario.ler',
  '/equipamentos/:id/situacoes': 'situacao.ler',
  '/equipamentos/a-revisar': 'equipamento.ler',
  '/equipamentos/apoio/cadastros': 'cadastro.ler',
  '/equipamentos/proximo-codigo': 'equipamento.ler',
  '/equipamentos/tipos': 'equipamento.ler',
  '/estoque/apoio': 'estoque.ler',
  '/estoque/depositos': 'estoque.ler',
  '/estoque/movimentos': 'estoque.ler',
  '/estoque/necessidade': 'estoque.ler',
  '/estoque/produtos': 'estoque.ler',
  '/estoque/produtos/:id/aplicacoes': 'estoque.ler',
  '/estoque/produtos/:id/conversoes': 'estoque.ler',
  '/estoque/reservas': 'estoque.ler',
  '/estoque/saldos': 'estoque.ler',
  '/financeiro/dre': 'financeiro.ler',
  '/financeiro/lancamentos': 'financeiro.ler',
  '/financeiro/plano': 'financeiro.ler',
  '/financeiro/titulos': 'financeiro.ler',
  '/ia/avaliacao/casos': 'ia.auditar',
  '/ia/avaliacao/rodadas': 'ia.auditar',
  '/ia/avaliacao/rodadas/:id': 'ia.auditar',
  '/ia/qualidade': 'ia.auditar',
  '/ia/registro': 'ia.auditar',
  '/ia/registro/:id': 'ia.auditar',
  '/inspecao/checklists': 'inspecao.ler',
  '/inspecao/checklists/:id/itens': 'inspecao.ler',
  '/inspecao/cobertura': 'inspecao.ler',
  '/inspecao/evidencias/:id/arquivo': 'inspecao.ler',
  '/inspecao/ocorrencias': 'inspecao.ler',
  '/inspecao/ocorrencias/:id/evidencias': 'inspecao.ler',
  '/inspecoes': 'inspecao.ler',
  '/inspecoes/:id/itens': 'inspecao.ler',
  '/inspecoes/viva': 'inspecao.ler',
  '/integracoes/configuracao': 'integracao.ler',
  '/integracoes/contingencias': 'integracao.ler',
  '/integracoes/contrato/v1': 'integracao.ler',
  '/integracoes/correspondencias': 'integracao.ler',
  '/integracoes/divergencias': 'integracao.ler',
  '/integracoes/ligacoes': 'integracao.ler',
  '/integracoes/lotes': 'integracao.ler',
  '/integracoes/lotes/:id': 'integracao.ler',
  '/integracoes/matriz': 'integracao.ler',
  '/integracoes/notas': 'integracao.ler',
  '/integracoes/registros': 'integracao.ler',
  '/integracoes/resumo': 'integracao.ler',
  '/integracoes/saidas/:id/arquivo': 'integracao.exportar',
  '/integracoes/sistemas': 'integracao.ler',
  '/integracoes/titulos': 'integracao.ler',
  '/integracoes/titulos/:id': 'integracao.ler',
  '/localidades/cep/:cep': 'cadastro.ler',
  '/manutencao/cadastros': 'manutencao.ler',
  '/manutencao/planos': 'manutencao.ler',
  '/manutencao/planos/:id': 'manutencao.ler',
  '/manutencao/realizacoes': 'manutencao.ler',
  '/manutencao/vencimentos': 'manutencao.ler',
  '/oficina/anexos/:id/arquivo': 'os.ler',
  '/oficina/cadastros': 'os.ler',
  '/oficina/ordens': 'os.ler',
  '/oficina/ordens/:id': 'os.ler',
  '/oficina/paradas-programadas': 'operacao.ler',
  '/operacao/apontamentos': 'operacao.ler',
  '/operacao/cadastros': 'operacao.ler',
  '/operacao/conciliacao/configuracao': 'operacao.ler',
  '/operacao/divergencias': 'operacao.ler',
  '/operacao/folhas': 'operacao.ler',
  '/operacao/folhas/:id': 'operacao.ler',
  '/operacao/folhas/leituras/:id/arquivo': 'operacao.ler',
  '/operacao/horas': 'operacao.ler',
  '/operacao/importacoes': 'operacao.ler',
  '/operacao/importacoes/:id': 'operacao.ler',
  '/operacao/leituras-do-turno': 'apontamento.registrar',
  '/operacao/motivos-de-parada': 'operacao.ler',
  '/operacao/pacotes-do-campo': 'apontamento.registrar',
  '/operacao/pacotes-do-campo/avisos': 'apontamento.registrar',
  '/operacao/paradas-por-motivo': 'operacao.ler',
  '/operacao/saidas-para-a-obra': 'operacao.ler',
  '/operacao/turnos': 'operacao.ler',
  '/orcamento/caixa': 'orcamento.ler',
  '/orcamento/cenarios/:cid/simulacao': 'orcamento.ler',
  '/orcamento/opcoes': 'orcamento.ler',
  '/orcamento/para-renovacao': 'orcamento.ler',
  '/orcamento/parametros': 'orcamento.ler',
  '/orcamento/previsto-realizado': 'orcamento.ler',
  '/orcamento/versoes': 'orcamento.ler',
  '/orcamento/versoes/:id': 'orcamento.ler',
  '/orcamento/versoes/:id/cenarios': 'orcamento.ler',
  '/orcamento/versoes/:id/sugestao-do-historico': 'orcamento.ler',
  '/painel/gestor': 'custo.ler',
  '/painel/gestor/resultado': 'custo.ler',
  '/painel/resumos': 'ia.perguntar',
  '/pessoas/anexos/:id/arquivo': 'documento_de_pessoa.ler',
  '/pessoas/aptidoes': 'documento_de_pessoa.ler',
  '/pessoas/aptidoes/elegiveis': 'aptidao.gravar',
  '/pessoas/documentos': 'documento_de_pessoa.ler',
  '/pessoas/documentos/:id/anexos': 'documento_de_pessoa.ler',
  '/pessoas/exigencias': 'documento_de_pessoa.ler',
  '/pessoas/funcoes': 'documento_de_pessoa.ler',
  '/pessoas/impedimentos': 'impedimento.ler',
  '/pessoas/impedimentos/alocacao': 'impedimento.ler',
  '/pessoas/impedimentos/obra/:id': 'impedimento.ler',
  '/pessoas/tipos-de-documento': 'documento_de_pessoa.ler',
  '/piloto/candidatos': 'piloto.gerir',
  '/piloto/carga': 'piloto.ler',
  '/piloto/grupo': 'piloto.ler',
  '/piloto/painel': 'piloto.ler',
  '/preditiva/base-minima': 'preditiva.ler',
  '/preditiva/catalogo': 'preditiva.ler',
  '/preditiva/falhas': 'preditiva.ler',
  '/preditiva/falhas/:ordemId': 'preditiva.ler',
  '/preditiva/investigacoes': 'preditiva.ler',
  '/preditiva/investigacoes/:id': 'preditiva.ler',
  '/preditiva/maquinas': 'preditiva.ler',
  '/preditiva/modelos': 'preditiva.ler',
  '/preditiva/modelos/:id/rodadas': 'preditiva.ler',
  '/preditiva/previsoes': 'preditiva.ler',
  '/preditiva/previsoes/:id/ordens': 'preditiva.ler',
  '/preditiva/propostas': 'preditiva.ler',
  '/preditiva/propostas/opcoes': 'preditiva.ler',
  '/preditiva/recorrencias': 'preditiva.ler',
  '/preditiva/resumo': 'preditiva.ler',
  '/receita/contratos/:id/regras': 'receita.ler',
  '/receita/margem': 'receita.ler',
  '/receita/medicoes': 'receita.ler',
  '/renovacao/criterios': 'renovacao.ler',
  '/renovacao/estudos': 'renovacao.ler',
  '/renovacao/estudos/:id': 'renovacao.ler',
  '/renovacao/frota': 'renovacao.ler',
  '/renovacao/maquinas/:id/historico': 'renovacao.ler',
  '/renovacao/opcoes': 'renovacao.ler',
  '/renovacao/parametros': 'renovacao.ler',
  '/renovacao/plano': 'renovacao.ler',
  '/renovacao/propostas': 'renovacao.ler',
  '/tecnico/apoio/alvos': 'documento_tecnico.ler',
  '/tecnico/documentos': 'documento_tecnico.ler',
  '/tecnico/documentos/:id': 'documento_tecnico.ler',
  '/tecnico/documentos/:id/arquivo': 'documento_tecnico.ler',
  '/tecnico/indice': 'documento_tecnico.ler',
  '/telemetria/conciliacao': 'telemetria.ler',
  '/telemetria/dispositivos/:id': 'telemetria.ler',
  '/telemetria/fila': 'telemetria.ler',
  '/telemetria/integracoes': 'telemetria.ler',
  '/telemetria/maquinas-para-ligar': 'telemetria.gerir',
  '/telemetria/maquinas/:id': 'telemetria.ler',
  '/telemetria/sinal': 'telemetria.ler',
};
